module.exports = __webpack_public_path__ + "img/pin.3ccc2db3.svg";